{
  "name": "paredes-y-asociados-front",
  "version": "1.0.0",
  "scripts": {
    "ng": "ng",
    "postinstall": "node -e \"const fs=require('fs');const p='node_modules/primeicons/primeicons.css';if(!fs.existsSync(p))process.exit(0);const c=fs.readFileSync(p,'utf8');const n=c.replace('font-display: block;','font-display: swap;');if(n!==c){fs.writeFileSync(p,n);console.log('Patched primeicons font-display to swap');}\"",
    "start": "ng serve -o",
    "build": "ng build",
    "watch": "ng build --watch --configuration development",
    "test": "ng test",
    "serve:ssr:paredes-y-asociados-front": "node dist/paredes-y-asociados-front/server/server.mjs"
  },
  "private": true,
  "dependencies": {
    "@angular/animations": "^17.3.0",
    "@angular/cdk": "^17.3.3",
    "@angular/common": "^17.3.0",
    "@angular/compiler": "^17.3.0",
    "@angular/core": "^17.3.0",
    "@angular/forms": "^17.3.0",
    "@angular/material": "^17.3.3",
    "@angular/platform-browser": "^17.3.0",
    "@angular/platform-browser-dynamic": "^17.3.0",
    "@angular/platform-server": "^17.3.0",
    "@angular/router": "^17.3.0",
    "@angular/service-worker": "^17.3.0",
    "@angular/ssr": "^17.3.3",
    "aos": "^2.3.4",
    "express": "^4.18.2",
    "lucide-angular": "^0.563.0",
    "ng-recaptcha": "^13.2.1",
    "ngx-countup": "^13.2.0",
    "ngx-fast-marquee": "^0.2.0",
    "ngx-pagination": "^6.0.3",
    "primeicons": "^7.0.0",
    "primeng": "^17.14.1",
    "rxjs": "~7.8.0",
    "swiper": "8.0.6",
    "tslib": "^2.3.0",
    "zone.js": "~0.14.3"
  },
  "devDependencies": {
    "@angular-devkit/build-angular": "^17.3.3",
    "@angular/cli": "^17.3.3",
    "@angular/compiler-cli": "^17.3.0",
    "@types/aos": "^3.0.7",
    "@types/express": "^4.17.17",
    "@types/jasmine": "~5.1.0",
    "jasmine-core": "~5.1.2",
    "karma": "~6.4.3",
    "karma-chrome-launcher": "~3.2.0",
    "karma-coverage": "~2.2.1",
    "karma-jasmine": "~5.1.0",
    "karma-jasmine-html-reporter": "~2.1.0"
  }
}
